import $ from 'jquery';
import { ajaxDelete } from '@/js/modules/ajax';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $(function () {
    const sortAddressPresets = () => {
      const sortedList = $('.load-preset__options--address')
        .find('.load-preset__option')
        .sort((leftOption, rightOption) => {
          return $(leftOption).find('.load-preset__load-address-preset').text() <
            $(rightOption).find('.load-preset__load-address-preset').text()
            ? -1
            : 1;
        });
      $('.load-preset__options--address').empty();
      sortedList.each((_, option) => {
        $(option).appendTo($('.load-preset__options--address'));
      });
    };

    $(document).on('submit', '.update-billable-address-form', (e) => {
      $(e.target).find('button[type=submit]').addClass('button-loading').prop('disabled', true);

      return false;
    });

    $(document).on('ajax:success', '.update-billable-address-form', (_, data) => {
      $.modal.close();
      $('.billable-address__address').html(data);
      $('.billable-address').removeClass('hide');
      $('.h-s-button--billable-add-shipping-address').addClass('hide');
      // The address was saved directly to the billable via the modal, so remove
      $('input[name="sync_client_address"]').remove();
    });

    $(document).on('click', '.save-address-preset-link', (e) => {
      e.preventDefault();
      const $formData = $(e.target)
        .parents('#modal--update-client-address')
        .find('form')
        .serialize();
      $.post(e.target.href, $formData, (modalAddressPreset) => {
        $(modalAddressPreset).appendTo('body').modal();
      });
    });

    $(document).on($.modal.CLOSE, '.modal--address-preset', (e) => {
      $(e.target).remove();
      $('#modal--update-client-address').find('.load-preset').removeClass('load-preset--active');
      $('#modal--update-client-address').modal('open');
    });

    $(document).on('click', '.p-button--save-address-preset', (e) => {
      e.preventDefault();
      const $form = $(e.target).closest('form');
      if ($form.find('.field--preset-title').val().trim().length === 0) {
        $form.find('.error-message').show();
        $form.find('.field--preset-title').focus();
        return false;
      } else {
        $form.find('.error-message').hide();

        $.post($form.attr('action'), $form.serialize(), (presetOptionHtml) => {
          const $option = $(presetOptionHtml);
          const id = $option.attr('data-id');
          const $container = $('.load-preset__options--address');
          const $existingOption = $container.find(`.load-preset__option[data-id=${id}]`);
          if ($existingOption.length > 0) {
            $existingOption.replaceWith(presetOptionHtml);
          } else {
            $option.appendTo($container);
          }

          sortAddressPresets();

          $container.siblings('.load-preset__link').removeClass('load-preset__link--disabled');
          $container.closest('.load-preset').removeClass('load-preset--active');
          $('.modal--address-preset').find('.close-modal').click();
        });
      }
    });

    $(document).on('keyup paste change', '.field--preset-title', (e) => {
      const $form = $(e.target).closest('form');
      if ($(e.target).val().trim().length === 0) {
        $form.find('.error-message').show();
      } else {
        $form.find('.error-message').hide();
      }
    });

    $(document).on('click', '.load-preset__load-address-preset', (e) => {
      e.preventDefault();
      $.get(e.target.href, (address) => {
        const $form = $(e.target).closest('#modal--update-client-address').find('form');
        $form.find('.field--address-address1').val(address.street1);
        $form.find('.field--address-address2').val(address.street2);
        $form.find('.field--address-country').val(address.country);
        $form.find('.field--address-region').val(address.region);
        $form.find('.field--address-city').val(address.city);
        $form.find('.field--address-postal-code').val(address.postal_code);
        $form.find('.field--address-phone').val(address.phone);

        $(e.target).closest('.load-preset').removeClass('load-preset--active');
      });
    });

    $(document).on('click', '.load-preset__edit-address-preset', (e) => {
      e.preventDefault();
      $.post(e.target.href, {}, (modalAddressPreset) => {
        $(modalAddressPreset).appendTo('body').modal();
      });
    });

    $(document).on('click', '.load-preset__delete-address-preset', (e) => {
      e.preventDefault();
      if (confirm('Are you sure?')) {
        const $container = $(e.target).closest('.load-preset__option');
        $container.addClass('load-preset__option--disabled');
        ajaxDelete(e.target.href, {}, () => {
          $container.remove();
          const $presets = $('.load-preset__options--address');
          if ($presets.find('.load-preset__option').length === 0) {
            $presets
              .closest('.load-preset')
              .removeClass('load-preset--active')
              .find('.load-preset__link')
              .addClass('load-preset__link--disabled');
          }
        });
      }
    });
  });
});
